import { buildCommonInvoiceCells } from './build-common-invoice-cells.util';
import type { SegmentInvoice } from '../types/invoice.type';
import type { InvoiceStatus } from '../types/invoice-status.type';
import type { InvoiceTableRow } from '../components/Tables/InvoiceListTable.component';

type Options = {
  onChangeStatus: (invoiceId: string, nextStatus: InvoiceStatus) => void | Promise<void>;
};

export function mapSegmentInvoiceToTableRow(invoice: SegmentInvoice, options: Options): InvoiceTableRow {
  const cells = buildCommonInvoiceCells(invoice, invoice.segmentParams.interval, options);

  return {
    id: invoice.id,
    status: invoice.status,
    cells: [
      cells.invoiceNumber,
      cells.status,
      cells.format,
      cells.period,
      cells.totalHT,
      cells.totalTTC,
      cells.createdAt,
    ],
  };
}
